import PostsSectionImplementation from '../implementation/sections/PostsSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiPostsSectionDTO,
  PostsSectionDTO,
} from '@lib/strapi/dtos/components/sections/postsSection.dto';

const PostsSection = (props: ComponentProps<PostsSectionDTO>) => {
  return <PostsSectionImplementation {...props}></PostsSectionImplementation>;
};

export default PostsSection;
